var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3.98861L10.0114 3L7 6.01139L3.98861 3L3 3.98861L6.01139 7L3 10.0114L3.98861 11L7 7.98861L10.0114 11L11 10.0114L7.98861 7L11 3.98861Z",
    fill: "#DE3535"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCancelIcon);
export default __webpack_public_path__ + "static/media/redCancelIcon.6f534703954461767e22b45447518a24.svg";
export { ForwardRef as ReactComponent };